import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/main/data-sharing.service';
import { PageOfReportRequest } from 'src/app/model/cms-vod-core/dealing-models/page-of-report-request.model';
import { ContentService } from 'src/app/services/cms-vod-core/contents-controller/content.service';
import { LicenseService } from 'src/app/services/cms-vod-core/license-controller/license.service';
import { ReportRequestService } from 'src/app/services/cms-vod-core/report-request-controller/report-request.service';
import { ValidationEventActivityLogService } from 'src/app/services/cms-vod-core/validation-event-log-controller/validation-event-activity-log.service';
import { VopKpiReportService } from 'src/app/services/cms-vod-core/vop-kpi-report-controller/vop-kpi-report.service';
import { UrlPrefixes } from '../../../../model/cms-btv-core/config-controller/config-url-prefix.model';
import { VodQueryParams } from '../../../../model/vod-query-params.model';
import { ContentIssueTypeService } from '../../../../services/cms-vod-core/content-issues-type/content-issue-type.service';
import { Utility } from '../../../../utility/utility';
import { ComingSoonContentsService } from 'src/app/services/cms-vod-core/coming-soon-contents/coming-soon-contents.service';

@Component({
  selector: 'app-report-request',
  templateUrl: './report-request.component.html',
  styleUrls: ['./report-request.component.css'],
})
export class ReportRequestComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoadingTable: boolean[] = [];
  pageOfReportRequest: PageOfReportRequest;
  reportPrefix: UrlPrefixes;
  subscription: Subscription;
  page: number = 0;
  reportType: string;
  vodQueryParams: VodQueryParams;

  constructor(
    private reportRequestService: ReportRequestService,
    private contentService: ContentService,
    private licenseService: LicenseService,
    private contentIssueTypeService: ContentIssueTypeService,
    private validationEventLogService: ValidationEventActivityLogService,
    private vopKpiDataService: VopKpiReportService,
    private dataSharing: DataSharingService,
    private route: ActivatedRoute,
    private comingSoonContentService: ComingSoonContentsService,
    public utility: Utility,
  ) {
    this.subscription = this.dataSharing.getReportUrlPrefix().subscribe((response) => {
      this.reportPrefix = response;
    });
    this.subscription = this.dataSharing.getQueryParams().subscribe((response) => {
      this.vodQueryParams = response;
    });
  }

  ngOnInit(): void {
    this.reportType = this.route.snapshot.params['type'];
    this.getAllReportRequests();
    this.utility.closeModalOnAnyWhere('modal-exportexcel');
  }

  ngAfterViewInit(): void {
    this.utility.openModal('modal-exportexcel');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getReportTypeActiveLicenseExcel(): void {
    this.isLoadingTable[0] = true;
    this.licenseService.getContentReportByActiveLicenseExcel().subscribe(
      (_) => {
        this.isLoadingTable[0] = false;

        this.getAllReportRequests();
      },
      (_) => {
        this.isLoadingTable[0] = false;
      },
    );
  }

  getReportTypeHasFutureLicenseExcel(): void {
    this.isLoadingTable[1] = true;

    this.licenseService.getContentHasFutureLicenseExcel().subscribe(
      (response) => {
        this.isLoadingTable[1] = false;

        this.getAllReportRequests();
      },
      (error) => {
        this.isLoadingTable[0] = false;
      },
    );
  }

  getReportTypeHasNoLicenseExcel(): void {
    this.isLoadingTable[2] = true;
    this.licenseService.getContentHasNoLicenseExcel().subscribe(
      (response) => {
        this.isLoadingTable[2] = false;
        this.getAllReportRequests();
      },
      (error) => {
        this.isLoadingTable[0] = false;
      },
    );
  }

  getReportTypeTbaLicenseExcel(): void {
    this.isLoadingTable[3] = true;

    this.licenseService.getContentTbaLicenseExcel().subscribe(
      (response) => {
        this.isLoadingTable[3] = false;

        this.getAllReportRequests();
      },
      (error) => {
        this.isLoadingTable[0] = false;
      },
    );
  }

  getReportTypeHasCommercialRights(): void {
    this.isLoadingTable[4] = true;

    this.licenseService.getContentHasCommercialRights().subscribe(
      (response) => {
        this.isLoadingTable[4] = false;
        this.getAllReportRequests();
      },
      (error) => {
        this.isLoadingTable[0] = false;
      },
    );
  }
  getContentReports(): void {
    this.contentService.getContentReport(this.vodQueryParams).subscribe((_) => {
      this.getAllReportRequests();
    });
  }

  getAllContentReports(): void {
    this.contentService.getContentReport().subscribe((_) => {
      this.getAllReportRequests();
    });
  }

  // getTrailerReports(): void {
  //   this.contentService.getTrailerReport(this.vodQueryParams).subscribe((_) => {
  //     this.getAllReportRequests();
  //   });
  // }

  getContentIssueTypesReport(): void {
    let startTime: number, endTime: number;
    let contentIssueTypeName: string;
    if (this.vodQueryParams.startTime) {
      startTime = this.vodQueryParams.startTime[0];
    }
    if (this.vodQueryParams.endTime) {
      endTime = this.vodQueryParams.endTime[0];
    }
    if (this.vodQueryParams.contentIssueTypeName) {
      contentIssueTypeName = this.vodQueryParams.contentIssueTypeName;
    }
    this.contentIssueTypeService.getContentIssueTypeReport(startTime, endTime, contentIssueTypeName).subscribe((_) => {
      this.getAllReportRequests();
    });
  }

  getValidationEventLogsReport(): void {
    this.validationEventLogService.generateValidationEventActivityLogsReport(this.vodQueryParams).subscribe((response) => {
      this.getAllReportRequests();
    });
  }

  getVopKpiDataReport(): void {
    this.vopKpiDataService.generateVopKpiDataReport(this.vodQueryParams).subscribe((response) => {
      this.getAllReportRequests();
    });
  }
  getComingSoonContentReport(): void {
    this.comingSoonContentService.report(this.vodQueryParams).subscribe((response) => {
      this.getAllReportRequests();
    });
  }

  getAllReportRequests(page?: any): void {
    let type: string[] = [];
    if (this.reportType == 'content' || this.reportType == 'cmsdashboard') {
      type.push('ContentReport');
    } else if (this.reportType == 'trailer') {
      type.push('TrailerContentReport');
    } else if (this.reportType == 'contentissuetype') {
      type.push('ContentIssueTypeReport');
    } else if (this.reportType == 'validationeventactivitylog') {
      type.push('ValidationEventActivityLogReport');
    } else if (this.reportType == 'vopkpidata') {
      type.push('VideoOperationKpiReport');
    } else if (this.reportType == 'comingsoon') {
      type.push('ComingsoonContentReport');
    } else if (this.reportType == 'deal') {
      type = [
        'ContentHasActiveLicense',
        'ContentHasFutureLicense',
        'ContentHasNoActiveLicense',
        'ContentsTBA',
        'ContentHasCommercialRights',
        'ContentReportAll',
        'ContentReport',
        'ComingsoonContentReport'
      ];
    }
    this.reportRequestService.getAllReportRequests(page, type).subscribe((response) => {
      this.pageOfReportRequest = response;
      type = [];
    });
  }
}
